import { getI18n } from "react-i18next";
import { VehiclePayments } from "Types/api/VehiclePayments";
import { AccountState, Payment, PaymentOffers, PaymentTypeOptions } from "Types/state";

export const LOADING_STATUS = "loading";
export type LOADING_STATUS = typeof LOADING_STATUS;
export const NO_OFFERS_STATUS = "noOffers";
export type NO_OFFERS_STATUS = typeof NO_OFFERS_STATUS;

export interface PaymentDataStatus {
    status: LOADING_STATUS | NO_OFFERS_STATUS;
    paymentInfoString?: undefined;
    paymentOffers?: undefined;
    selectedOffer?: undefined;
}
export type PaymentData =
    | PaymentDataStatus
    | {
          status?: undefined;
          paymentInfoString: string;
          paymentOffers: PaymentOffers;
          selectedOffer: number;
      };

export function monthlyPaymentDisplay(
    account: AccountState,
    payments: VehiclePayments,
    selectedPaymentIndex: PaymentTypeOptions,
    offerIndex?: number
): PaymentData | undefined {
    if (!selectedPaymentIndex) {
        return undefined;
    }

    if (payments && payments[selectedPaymentIndex]) {
        const selectedPayment = payments[selectedPaymentIndex] as Payment;

        if (
            selectedPayment.data_hash &&
            selectedPayment.request_hash &&
            selectedPayment.data_hash !== selectedPayment.request_hash
        ) {
            return { status: LOADING_STATUS };
        }

        if (!selectedPayment.request_hash || !selectedPayment.data_hash) {
            return { status: LOADING_STATUS };
        }

        let selectedOffer: number;

        if (offerIndex !== undefined) {
            selectedOffer = offerIndex;
        } else if (selectedPayment.selected_offer !== null && selectedPayment.selected_offer !== undefined) {
            selectedOffer = selectedPayment.selected_offer;
        } else {
            selectedOffer = 0;
        }

        const paymentOffers = selectedPayment.offers;

        if (paymentOffers && selectedOffer >= 0 && paymentOffers[selectedOffer]) {
            const paymentInfoString = computePaymentInfoString(account, selectedPaymentIndex);
            return {
                paymentInfoString,
                paymentOffers,
                selectedOffer,
            };
        }
        return { status: NO_OFFERS_STATUS };
    }

    return { status: NO_OFFERS_STATUS };
}

export function computePaymentInfoString(
    account: AccountState,
    selectedPaymentIndex: PaymentTypeOptions
): string {
    const i18n = getI18n();
    let infoString;
    if (account && account.account_disclaimers) {
        switch (selectedPaymentIndex) {
            case "cash":
                infoString = account.account_disclaimers.electric_payment_label_cash;
                break;
            case "lease":
                infoString = account.account_disclaimers.electric_payment_label_lease;
                break;
            case "loan":
                infoString = account.account_disclaimers.electric_payment_label_loan;
                break;
            default:
                break;
        }
    }
    return infoString || i18n.t("CalculatedPayment.paymentInfo.default");
}
